/* eslint-disable camelcase */
import Vue from 'vue'
import Router from 'vue-router'

// Containers
import Full from '@/containers/Full'

// Views
import Dashboard from '@/views/Dashboard'
import Login from '@/auth/Login'
import Tables from '@/views/tables/Tables'
import energy_companies from '@/views/energy_companies/energy_companies'
import trucking_companies from '@/views/trucking_companies/trucking_companies'
import trucking_company from '@/views/trucking_companies/trucking_company'
import reports from '@/views/reports/reports'
import hauls from '@/views/hauls/hauls'
import tests from '@/views/hauls/tests'
import haul from '@/views/hauls/haul'
// import haul_old from '@/views/hauls/haul_old'
import trucks from '@/views/trucks/trucks'
import truck from '@/views/trucks/truck'
import agreements from '@/views/agreements/agreements'
import agreements_pending from '@/views/agreements/agreements_pending'
import agreement from '@/views/agreements/agreement'
import locations from '@/views/locations/m_locations'
import m_location from '@/views/locations/m_location'
import users from '@/views/users/users'
import user from '@/views/users/user'
import userDocument from '@/views/users/userDocument'
import mTargets from '@/views/m_targets/m_targets'
import mTarget from '@/views/m_targets/m_target'
import mTruckTypes from '@/views/m_truck_types/m_truck_types'
import mTruckType from '@/views/m_truck_types/m_truck_type'
import mFluidTypes from '@/views/m_fluid_types/m_fluid_types'
import mFluidType from '@/views/m_fluid_types/m_fluid_type'
import Notification from '@/views/notification/notifications'
import mLocationTypes from '@/views/location_types/m_location_types'
import mLocationType from '@/views/location_types/m_location_type'
import mOperatingAreas from '@/views/operating_areas/m_operating_areas'
import mOperatingArea from '@/views/operating_areas/m_operating_area'
import m_energy_company from '@/views/energy_companies/m_energy_company'
import mRoles from '@/views/roles/m_roles'
import mRole from '@/views/roles/m_role'
import keys from '@/views/keys/keys'
import mServices from '@/views/services/m_services'
import mService from '@/views/services/m_service'
import folders from '@/views/folders/folders'
import folder from '@/views/folders/folder'
import t_agreements from '@/views/terminal_agreements/terminal_agreements'
import t_agreements_pending from '@/views/terminal_agreements/terminal_agreements_pending'
import t_agreement from '@/views/terminal_agreements/terminal_agreement'
import indexes from '@/views/terminal_agreements/indexes'
import index_detail from '@/views/terminal_agreements/index_detail'
import wti from '@/views/terminal_agreements/wti'
import wti_detail from '@/views/terminal_agreements/wti_detail'
import mexport from '@/views/hauls/export'

import mProfile from '@/views/profile/profile'
import forgotPassword from '@/auth/ForgotPassword'
// logs views
import logs from '@/views/logs/logs'
import log from '@/views/logs/log'
// Views - Pages
import Page404 from '@/views/pages/Page404'
import Page500 from '@/views/pages/Page500'

// Auth Services

import auth from '@/auth/auth'

import terminal_companies from '@/views/terminal_companies/terminal_companies'
import terminal_company from '@/views/terminal_companies/terminal_company'
import terminals from '@/views/terminals/terminals'
import terminal from '@/views/terminals/terminal'

import dash_truckin_admin from '@/views/dashboard/Dash'

import powerbis from '@/views/powerbi/pwbi_listing'
import powerbi from '@/views/powerbi/pwbi_detail'
import other_report from '@/views/powerbi/other_report'
import duplicated_hauls from '@/views/hauls/duplicated_hauls'
import discrepancy_report from '@/views/hauls/discrepancy_report'
import receipts_wo_hauls from '@/views/receipt/receipt'
import request_hauls from '@/views/hauls/request_hauls'
import request_h from '@/views/hauls/request_h'
import invoices from '@/views/invoices/invoices'
import invoice from '@/views/invoices/invoice'
import invoices_hauls from '@/views/invoices/haul_invoices'
import request_haul_notifications from '@/views/request_hauls/notifications'
import request_haul_notification from '@/views/request_hauls/notification'
import invoice_haul_notifications from '@/views/invoices/notifications'
import invoice_haul_notification from '@/views/invoices/notification'
import trucks_units from '@/views/trucks_unit/trucks_units'
import trucks_unit from '@/views/trucks_unit/trucks_unit'
import altex_check from '@/views/receipt/altex'

// Intraday Report
import intraday_report from '@/views/intraday/intraday_report'

import hazards from '@/views/cnr/hazards'
import controls from '@/views/cnr/controls'
import hazard from '@/views/cnr/hazard'
import control from '@/views/cnr/control'
import tdgs from '@/views/cnr/tdgs'
import tdg from '@/views/cnr/tdg'

import petrotranz_report from '@/views/receipt/petrotranz_report'
import invoice_customers from '@/views/invoices/invoice_customers'
import invoice_customer from '@/views/invoices/invoice_customer'
import invoice_contracts from '@/views/invoices/invoice_contracts'
import invoice_contract from '@/views/invoices/invoice_contract'
import invoice_adjusts from '@/views/invoices/invoice_adjusts'
import invoice_adjust from '@/views/invoices/invoice_adjust'
import invoice_prices from '@/views/invoices/invoice_prices'
import invoice_price from '@/views/invoices/invoice_price'

import agreement_pending_detail from '@/views/agreements/agreement_pending_d'
import update_volume_estimate from '@/views/isolera/update_volume_estimate'

Vue.use(Router)

// Ajuste
export default new Router({
  mode: 'hash', // Demo is living in GitHub.io, so required!
  root: '/',
  linkActiveClass: 'open active',
  scrollBehavior: () => ({ y: 0 }),
  relative: true,
  base: __dirname,
  routes: [
    {
      path: '/forgot_password',
      name: 'Forgot Password',
      component: forgotPassword
      // beforeEnter: requiredAuth
    },
    {
      path: '/tests',
      name: 'Hauls',
      component: tests
      // beforeEnter: requiredAuth
    },
    {
      path: '/',
      redirect: '/dashboard',
      name: 'Home',
      component: Full,
      children: [
        {
          path: 'dashboard',
          name: 'Dashboard',
          component: Dashboard,
          beforeEnter: requiredAuth
        },
        {
          path: 'targets',
          name: 'Targets',
          component: mTargets,
          beforeEnter: requiredAuth
        },
        {
          path: 'intraday',
          name: 'Intraday Report',
          component: intraday_report,
          beforeEnter: requiredAuth
        },
        {
          path: '/target/:id',
          name: 'Target',
          props: true,
          component: mTarget,
          beforeEnter: requiredAuth
        },
        {
          path: 'tables',
          name: 'Tables',
          component: Tables,
          beforeEnter: requiredAuth
        },
        {
          path: 'users',
          name: 'Users',
          component: users
          // beforeEnter: requiredAuth
        },
        {
          path: 'user/:id',
          name: 'User',
          props: true,
          component: user,
          beforeEnter: requiredAuth
        },
        {
          path: 'user/:id/documents/:idDocument',
          name: 'userDocument',
          props: true,
          component: userDocument,
          beforeEnter: requiredAuth
        },
        {
          path: 'trucks',
          name: 'Trucks',
          component: trucks,
          beforeEnter: requiredAuth
        },
        {
          path: 'truck/:id',
          name: 'Truck',
          props: true,
          component: truck,
          beforeEnter: requiredAuth
        },
        {
          path: 'agreements',
          name: 'Agreements',
          component: agreements,
          beforeEnter: requiredAuth
        },
        {
          path: '/agreement/:id',
          name: 'Agreement',
          props: true,
          component: agreement,
          beforeEnter: requiredAuth
        },
        {
          path: 'terminal_agreements',
          name: 'Terminal Agreements',
          component: t_agreements,
          beforeEnter: requiredAuth
        },
        {
          path: '/terminal_agreement/:id',
          name: 'Terminal Agreement',
          props: true,
          component: t_agreement,
          beforeEnter: requiredAuth
        },
        {
          path: 'energy_companies',
          name: 'Energy Company',
          component: energy_companies,
          beforeEnter: requiredAuth
        },
        {
          path: '/energy_company/:id',
          name: 'Energy Companies',
          props: true,
          component: m_energy_company,
          beforeEnter: requiredAuth
        },
        {
          path: 'trucking_companies',
          name: 'Trucking Companies',
          component: trucking_companies,
          beforeEnter: requiredAuth
        },
        {
          path: 'reports',
          name: 'Reports',
          component: reports,
          beforeEnter: requiredAuth
        },
        {
          path: 'hauls',
          name: 'Hauls',
          component: hauls,
          beforeEnter: requiredAuth
        },
        {
          path: '/haul/:id',
          name: 'Haul',
          props: true,
          component: haul,
          beforeEnter: requiredAuth
        },
        // {
        //   path: '/haul_old/:id',
        //   name: 'Haul Old',
        //   props: true,
        //   component: haul_old,
        //   beforeEnter: requiredAuth
        // },
        {
          path: 'locations',
          name: 'Locations',
          component: locations,
          beforeEnter: requiredAuth
        },
        {
          path: '/location/:id',
          name: 'Location',
          props: true,
          component: m_location,
          beforeEnter: requiredAuth
        },
        {
          path: 'operating_areas',
          name: 'Operating Areas',
          component: mOperatingAreas,
          beforeEnter: requiredAuth
        },
        {
          path: '/operating_area/:id',
          name: 'Operating Area',
          props: true,
          component: mOperatingArea,
          beforeEnter: requiredAuth
        },
        {
          path: '/trucking_company/:id',
          name: 'Trucking Company',
          props: true,
          component: trucking_company,
          beforeEnter: requiredAuth
        },
        {
          path: 'fluid_types',
          name: 'Fluid Types',
          component: mFluidTypes,
          beforeEnter: requiredAuth
        },
        {
          path: 'notification',
          name: 'Notifications',
          component: Notification,
          beforeEnter: requiredAuth
        },
        {
          path: '/fluid_type/:id',
          name: 'Fluid Type',
          props: true,
          component: mFluidType,
          beforeEnter: requiredAuth
        },
        {
          path: 'truck_types',
          name: 'Truck Types',
          component: mTruckTypes,
          beforeEnter: requiredAuth
        },
        {
          path: '/truck_type/:id',
          name: 'Truck Type',
          props: true,
          component: mTruckType,
          beforeEnter: requiredAuth
        },
        {
          path: 'location_types',
          name: 'Locations Types',
          component: mLocationTypes,
          beforeEnter: requiredAuth
        },
        {
          path: '/location_type/:id',
          name: 'Locations Type',
          props: true,
          component: mLocationType,
          beforeEnter: requiredAuth
        },
        {
          path: 'roles',
          name: 'Roles',
          component: mRoles,
          beforeEnter: requiredAuth
        },
        {
          path: '/role/:id',
          name: 'Role',
          props: true,
          component: mRole,
          beforeEnter: requiredAuth
        },
        {
          path: 'services',
          name: 'Services',
          component: mServices,
          beforeEnter: requiredAuth
        },
        {
          path: 'keys',
          name: 'EC-Keys',
          component: keys,
          beforeEnter: requiredAuth
        },
        {
          path: '/service/:id',
          name: 'Service',
          props: true,
          component: mService,
          beforeEnter: requiredAuth
        },
        {
          path: 'folders',
          name: 'Folders',
          component: folders,
          beforeEnter: requiredAuth
        },
        {
          path: '/folder/:id',
          name: 'Folder',
          props: true,
          component: folder,
          beforeEnter: requiredAuth
        },
        {
          path: '/profile/:id',
          name: 'Profile',
          props: true,
          component: mProfile,
          beforeEnter: requiredAuth
        },
        {
          path: 'logs',
          name: 'Logs',
          component: logs,
          beforeEnter: requiredAuth
        },
        {
          path: '/log/:id',
          name: 'Log',
          props: true,
          component: log,
          beforeEnter: requiredAuth
        },
        {
          path: 'terminal_companies',
          name: 'Terminal Companies',
          component: terminal_companies,
          beforeEnter: requiredAuth
        },
        {
          path: '/terminal_company/:id',
          name: 'Terminal Company',
          props: true,
          component: terminal_company,
          beforeEnter: requiredAuth
        },
        {
          path: 'terminal_agreements_pending',
          name: 'Pending Terminal Agreements',
          component: t_agreements_pending,
          beforeEnter: requiredAuth
        },
        {
          path: 'indexes',
          name: 'Indexes',
          component: indexes,
          beforeEnter: requiredAuth
        },
        {
          path: '/index/:id',
          name: 'Index',
          props: true,
          component: index_detail,
          beforeEnter: requiredAuth
        },
        {
          path: 'wti',
          name: 'WTIs',
          component: wti,
          beforeEnter: requiredAuth
        },
        {
          path: '/wti/:id',
          name: 'WTI',
          props: true,
          component: wti_detail,
          beforeEnter: requiredAuth
        },
        {
          path: 'other',
          name: 'Export',
          props: true,
          component: mexport,
          beforeEnter: requiredAuth
        },
        {
          path: 'terminals',
          name: 'Terminals',
          component: terminals,
          beforeEnter: requiredAuth
        },
        {
          path: '/terminal/:id',
          name: 'Terminal',
          props: true,
          component: terminal,
          beforeEnter: requiredAuth
        },
        {
          path: 'agreements_pending',
          name: 'Pending Agreements',
          component: agreements_pending,
          beforeEnter: requiredAuth
        },
        {
          path: 'dash',
          name: 'Dash Trucking Company Admin',
          component: dash_truckin_admin,
          beforeEnter: requiredAuth
        },
        {
          path: 'powerbi',
          name: 'Power BIs',
          component: powerbis,
          beforeEnter: requiredAuth
        },
        {
          path: '/powerbi/:id',
          name: 'Power BI',
          props: true,
          component: powerbi,
          beforeEnter: requiredAuth
        },
        {
          path: 'monthly_report',
          name: 'Monthly Report',
          component: other_report,
          beforeEnter: requiredAuth
        },
        {
          path: 'duplicated_hauls',
          name: 'Duplicated Hauls',
          component: duplicated_hauls,
          beforeEnter: requiredAuth
        },
        {
          path: 'discrepancy_report',
          name: 'Discrepancy Report',
          component: discrepancy_report,
          beforeEnter: requiredAuth
        },
        {
          path: 'receipts_wo_hauls',
          name: 'Receipts without Hauls',
          component: receipts_wo_hauls,
          beforeEnter: requiredAuth
        },
        {
          path: 'request_hauls',
          name: 'Request Hauls',
          component: request_hauls,
          beforeEnter: requiredAuth
        },
        {
          path: 'request_hauls_trucking',
          name: 'Request Hauls',
          component: request_h,
          beforeEnter: requiredAuth
        },
        {
          path: 'invoices',
          name: 'Invoices',
          component: invoices,
          beforeEnter: requiredAuth
        },
        {
          path: '/invoice/:id',
          name: 'Invoice',
          props: true,
          component: invoice,
          beforeEnter: requiredAuth
        },
        {
          path: 'invoices_hauls',
          name: 'Invoices Hauls',
          component: invoices_hauls,
          beforeEnter: requiredAuth
        },        
        {
          path: 'request_haul_notifications',
          name: 'Request Haul Notifications',
          component: request_haul_notifications,
          beforeEnter: requiredAuth
        },
        {
          path: '/request_haul_notification/:id',
          name: 'Request Haul Notification',
          props: true,
          component: request_haul_notification,
          beforeEnter: requiredAuth
        },        
        {
          path: 'invoice_haul_notifications',
          name: 'Invoice Haul Notifications',
          component: invoice_haul_notifications,
          beforeEnter: requiredAuth
        },
        {
          path: '/invoice_haul_notification/:id',
          name: 'Invoice Haul Notification',
          props: true,
          component: invoice_haul_notification,
          beforeEnter: requiredAuth
        },
        {
          path: 'trucks_units',
          name: 'TrucksUnits',
          component: trucks_units,
          beforeEnter: requiredAuth
        },
        {
          path: 'trucks_unit/:id',
          name: 'TrucksUnit',
          props: true,
          component: trucks_unit,
          beforeEnter: requiredAuth
        },
        {
          path: 'altex_check',
          name: 'Altex Ticket Check',
          component: altex_check,
          beforeEnter: requiredAuth
        },
        {
          path: 'hazards',
          name: 'Hazards',
          component: hazards,
          beforeEnter: requiredAuth
        },
        {
          path: 'controls',
          name: 'Controls',
          component: controls,
          beforeEnter: requiredAuth
        },
        {
          path: '/hazard/:id',
          name: 'Hazard',
          props: true,
          component: hazard,
          beforeEnter: requiredAuth
        },
        {
          path: '/control/:id',
          name: 'Control',
          props: true,
          component: control,
          beforeEnter: requiredAuth
        },
        {
          path: 'tdgs',
          name: 'TDGs',
          component: tdgs,
          beforeEnter: requiredAuth
        },
        {
          path: '/tdg/:id',
          name: 'TDG',
          props: true,
          component: tdg,
          beforeEnter: requiredAuth
        },
        {
          path: 'petrotranz_report',
          name: 'PetroTranz Report',
          component: petrotranz_report,
          beforeEnter: requiredAuth
        },
        {
          path: 'invoice_customers',
          name: 'Invoice Customer',
          component: invoice_customers,
          beforeEnter: requiredAuth
        }, 
        {
          path: 'invoice_contracts',
          name: 'Invoice Contract',
          component: invoice_contracts,
          beforeEnter: requiredAuth
        }, 
        {
          path: 'invoice_adjusts',
          name: 'Invoice Adjust',
          component: invoice_adjusts,
          beforeEnter: requiredAuth
        }, 
        {
          path: 'invoice_prices',
          name: 'Invoice Prices',
          component: invoice_prices,
          beforeEnter: requiredAuth
        }, 
        {
          path: '/invoice_price/:id',
          name: 'Invoice Price',
          props: true,
          component: invoice_price,
          beforeEnter: requiredAuth
        },
        {
          path: '/invoice_adjust/:id',
          name: 'Invoice Adjust',
          props: true,
          component: invoice_adjust,
          beforeEnter: requiredAuth
        },
        {
          path: '/invoice_customer/:id',
          name: 'Invoice Customer',
          props: true,
          component: invoice_customer,
          beforeEnter: requiredAuth
        },
        {
          path: '/invoice_contract/:id',
          name: 'Invoice Contract',
          props: true,
          component: invoice_contract,
          beforeEnter: requiredAuth
        },
        {
          path: '/agreement_pending_detail/:id',
          name: 'Detail Pending Agreement',
          props: true,
          component: agreement_pending_detail,
          beforeEnter: requiredAuth
        },
        {
          path: 'update_volume_estimate',
          name: 'Update Volume Estimate',
          component: update_volume_estimate,
          beforeEnter: requiredAuth
        },
      ]
    },
    {
      path: '/auth',
      redirect: 'login',
      name: 'Auth',
      component: {
        render (c) { return c('router-view') }
      },
      children: [
        {
          path: '/login',
          name: 'Login',
          component: Login,
          beforeEnter: readyIsLogued
        },
        {
          path: '/logout',
          name: 'Logout',
          beforeEnter (to, from, next) {
            auth.logout()
            next('/login')
          }
        }
      ]
    },
    {
      path: '/pages',
      redirect: '/pages/404',
      name: 'Pages',
      component: {
        render (c) { return c('router-view') }
      },
      children: [
        {
          path: '404',
          name: 'Page404',
          component: Page404
        },
        {
          path: '500',
          name: 'Page500',
          component: Page500
        }
      ]
    },
    { path: '*', component: Page404 }
  ]
})

function requiredAuth (to, from, next) {
  if (!auth.isLoguedIn()) {
    next({
      path: '/login',
      query: { redirect: to.fullPath }
    })
  } else {
    next()
  }
}

function readyIsLogued (to, from, next) {
  if (auth.isLoguedIn()) {
    next({
      path: '/', // dashboard
      query: { redirect: to.fullPath }
    })
  } else {
    next()
  }
}



// WEBPACK FOOTER //
// ./src/router/index.js